import React, { useState } from 'react';
import ReleaseIdCardContext from '.';
import { PermitErrorModal } from '../search';

interface Props {
  children: React.ReactNode;
}
const ReleaseIdCardProvider = ({ children }: Props): React.ReactElement => {
  const [permitError, setPermitError] = useState<PermitErrorModal>({
    open: false,
    errorExists: false,
  });
  return (
    <ReleaseIdCardContext.Provider
      value={{
        permitError,
        setPermitError,
      }}
    >
      {children}
    </ReleaseIdCardContext.Provider>
  );
};

ReleaseIdCardProvider.displayName = 'Release Id Card Provider';
export default ReleaseIdCardProvider;
